import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FC } from 'react';
import css from './style.module.scss';
interface Props {
  onClose: () => void;
}
const BrandBookFormCloseButton: FC<Props> = t0 => {
  const $ = _c(3);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image src="/assets/images/brandQuiz/close.png" alt="close" width={46} height={46} className={css.closeImage} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <button className={css.closeButton} onClick={onClose}>{t1}</button>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default BrandBookFormCloseButton;